// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Colors } from "../../assets/Colors";
import { DynamicTablev3 } from "../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../components/form/HrdInputGenerator";
import { useForm } from "../../components/isRequired";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../fetchers";
import { toast } from "react-toastify";
import { maxPageGlobal } from "../../assets/config";

const MonitoringKendaraan = ({}) => {
  let initialState = {
    Bulan: new Date(),
    BisnisUnitID: "U0002",
  };

  const validations = [];

  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const [data, setData] = useState(null);
  const [dataUpkeep, setDataUpkeep] = useState(null);
  const mutationData = useMutation((param) =>
    fetchGet(
      "Procurement/Kendaraan/monitoring/" +
        param.BisnisUnitID +
        "/" +
        param.Bulan +
        "/" +
        param.Tahun
    )
  );
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "MSR",
    BisnisUnitID: "U0002",
    Bagian: "B",
    Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
    Tahun: new Date(values.Bulan).getFullYear().toString(),
  });
  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const header = [
    { name: "Transaksi Kendaraan ID", key: "TKendaraanID", modifiers: "Text" },
    { name: "KendaraanID", key: "KendaraanID", modifiers: "Text" },
    {
      name: "Nama Kendaraan",
      key: "NamaGeneralServiceUnit",
      modifiers: "Text",
    },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "Tanggal", key: "Tanggal", modifiers: "Date" },
    { name: "Status", key: "Status", modifiers: "Text" },
    { name: "Actions", key: "Edit", modifiers: "LihatKendaraan" },
  ];

  const filterData = (event) => {
    setSearch(event.target.value);
  };
  const filterApi = () => {
    let bagian = "B";
    if (values.Bagian) bagian = values.Bagian;
    setParam({
      start: start,
      count: count,
      search: search,
      BisnisUnitID: values.BisnisUnitID,
      Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: new Date(values.Bulan).getFullYear().toString(),
      Bagian: bagian,
    });
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"BisnisUnit"}
                      name={"BisnisUnitID"}
                      title={"BisnisUnit"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"bulan"}
                      name={"Bulan"}
                      title={"Bulan"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>

                    <button
                      type="button"
                      onClick={filterApi}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 px-7 py-2 text-center mr-2 mb-2 "
                    >
                      Buka
                    </button>
                  </div>
                </div>

                <div className="flex flex-col items-center content-center ">
                  <DynamicTablev3
                    data={mutationData.data}
                    header={header}
                    menuController={filterData}
                    value={search}
                    name={"Nama"}
                    title={"Report Jurnal"}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MonitoringKendaraan;
